import { createRouter, createWebHistory } from "vue-router";
import { useMainStore } from "@/stores/store";

const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "main" */ "../views/home/Home.vue")
  },
  {
    path: "/missions",
    component: () =>
      import(/* webpackChunkName: "main" */ "../views/home/Missions.vue")
  },
  {
    path: "/mission/:id",
    component: () =>
      import(/* webpackChunkName: "main" */ "../views/home/Overview.vue")
  },

  {
    path: "/:catchAll(.*)",
    component: () => import(/* webpackChunkName: "404" */ "../views/404.vue")
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior(to, from, savedPosition) {
    // If the user manually scrolled and then went back, restore the position
    if (savedPosition) {
      return savedPosition;
    } else {
      // Always scroll to the top when navigating
      return { top: 0 };
    }
  }
});

export default router;
